export const scrollToElement = (classname, negativeOffset) => {
  if (
    typeof document !== 'undefined' &&
    typeof window !== 'undefined' &&
    document.getElementsByClassName(classname)?.length > 0
  ) {
    window.scrollTo({
      top: document.getElementsByClassName(classname)[0].offsetTop - parseInt(negativeOffset, 10),
      left: 0,
      behavior: 'smooth'
    })
  }
}

export {}
